import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInvite = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.1665 2.5C15.4979 2.5 16.5862 3.54077 16.6623 4.85311L16.6665 5V8.62508L17.1614 8.40517C17.6728 8.17786 18.2634 8.53058 18.3275 9.06968L18.3332 9.16667V15.8333C18.3332 16.712 17.6533 17.4318 16.7909 17.4954L16.6665 17.5H3.33317C2.45454 17.5 1.7347 16.8201 1.67108 15.9577L1.6665 15.8333V9.16667C1.6665 8.607 2.2287 8.21057 2.74734 8.37099L2.83829 8.40517L3.33317 8.62508V5C3.33317 3.6686 4.37394 2.58028 5.68628 2.50424L5.83317 2.5H14.1665ZM16.6665 10.449L10.6768 13.1111C10.2458 13.3026 9.75392 13.3026 9.32292 13.1111L3.33317 10.449V15.8333H16.6665V10.449ZM14.1665 4.16667H5.83317C5.37294 4.16667 4.99984 4.53977 4.99984 5V9.36583L9.99984 11.5881L14.9998 9.36583V5C14.9998 4.53977 14.6268 4.16667 14.1665 4.16667ZM9.99984 6.66667C10.4601 6.66667 10.8332 7.03977 10.8332 7.5C10.8332 7.92736 10.5115 8.27959 10.097 8.32773L9.99984 8.33333H8.33317C7.87294 8.33333 7.49984 7.96023 7.49984 7.5C7.49984 7.07264 7.82154 6.72041 8.23599 6.67227L8.33317 6.66667H9.99984Z"
	})
});
export default SvgInvite;
